import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('customer.routes.index'),
        name: 'customer',
        child: false,
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer' },
                    disable: true,
                },
            ],
            showName: i18n.t('customer.breadcrumbs.index'),
        },
        props: true,
    },
    {
        path: '/' + i18n.t('customer.routes.create'),
        name: 'customer.create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer' },
                    disable: false,
                },
                {
                    text: i18n.t('customer.breadcrumbs.create'),
                    to: { name: 'customer.create' },
                    disable: true,
                },
            ],
            whitelabel: true,
        },
    },
    {
        path: '/' + i18n.t('customer.routes.edit') + '/:id',
        name: 'customer.edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer' },
                    disable: false,
                },
                {
                    text: i18n.t('customer.breadcrumbs.edit'),
                    to: { name: 'customer.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('customer.routes.show') + '/:id',
        name: 'customer.show',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/customers/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('customer.breadcrumbs.index'),
                    to: { name: 'customer' },
                    disable: false,
                },
                {
                    text: i18n.t('customer.breadcrumbs.show'),
                    to: { name: 'customer.show' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
